import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_URL = "https://correctivemotion.com";
const DEFAULT_IMG = `${SITE_URL}/og-image.jpg`;

/**
 * Injects canonical meta tags + JSON-LD on any page.
 *  - title / description
 *  - canonical
 *  - Open Graph + Twitter tags
 *  - one or more JSON-LD blocks
 */
export const Seo = ({
  title,
  description,
  path = "/",
  image = DEFAULT_IMG,
  schema = [],
  keywords,
  noindex = false,
}) => {
  const url = `${SITE_URL}${path.startsWith("/") ? path : `/${path}`}`;
  const jsonLd = Array.isArray(schema) ? schema : [schema];

  return (
    <Helmet>
      <title>{title}</title>
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      {description && <meta name="description" content={description} />}
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={url} />

      <meta property="og:site_name" content="Corrective Motion" />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={image} />

      {jsonLd.filter(Boolean).map((obj, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(obj)}
        </script>
      ))}
    </Helmet>
  );
};

export default Seo;
